module.exports = {"locales":["cs","sk","hu"],"defaultLocale":"sk","shallowLocale":"sk"}